import {Anim} from '/assets/js/modules/Anim.js';

// ==================================================================
// gHeader_item-downをホバーすると、overlayが発動
// ==================================================================
const overlay = new Anim('.overlay');
const $downs = $('.gHeader_item-down');

let hoverEl = [] // 該当する要素を入れていく

// 時間をずらしてホバーしている要素があればenter,なかったらleave
$downs.on({
	mouseenter:function (){
		hoverEl.push(this)
		setTimeout(() => {
			hoverEl.length > 0 && overlay.enter() // hoverEl内が0より大きいかつenterしていたら
		}, 10) // 10ミリ秒でジャッジ
	},
	mouseleave:function (){
		hoverEl = hoverEl.filter((item) => item !=  this)
		setTimeout(() => {
			hoverEl.length == 0 && overlay.leave()
		}, 10)
	},
})

// ==================================================================
// gHeader_navBtn
// ==================================================================
const example = new Anim('.overlay');

$(document).on('click', '.gHeader_navBtn', async () => {
	console.log('before anim', example.isEnter)
	await example.toggle();
	console.log('after anim', example.isEnter)
})